import { computed } from "@vue/composition-api";
import ui from "@/store/modules/ui";
import annotations from "@/store/modules/annotations";

export default function useBasicStyles() {
  const circleStyles = computed(() => {
    const style = {
      opacity: ui.annotationAlpha,
      "--fill": ui.shapeColor
    };
    // Interact to user action if WIP
    if (annotations.getState === "wip") {
      Object.assign(style, {
        cursor: "pointer",
        "--stroke-width-hover": ui.circleRadius / 2
      });
      // Don't react to user action if Finished or Empty
    } else {
      Object.assign(style, {
        cursor: "not-allowed",
        "--stroke-width-hover": 0
      });
    }
    return style;
  });

  const lineStyle = computed(() => {
    const style = {
      opacity: ui.annotationAlpha,
      strokeWidth: ui.strokeWidth,
      "--stroke": ui.shapeColor
    };

    // Interact to user action if WIP
    if (annotations.getState === "wip") {
      Object.assign(style, {
        cursor: "pointer",
        "--stroke-hover": "greenyellow"
      });
      // If finished or empty, don't react to user action
    } else {
      Object.assign(style, {
        cursor: "not-allowed",
        "--stroke-hover": ui.shapeColor
      });
    }

    return style;
  });

  return {
    circleStyles,
    lineStyle
  };
}
